interface LoadingSpinnerProps {
  size?: number;
  label?: string;
}

export function LoadingSpinner({ size = 18, label }: LoadingSpinnerProps) {
  return (
    <div className="inline-flex items-center gap-2 text-dash-secondary text-sm">
      <span
        className="inline-block animate-spin rounded-full border-2 border-dash-border/50 border-t-accent"
        style={{ width: size, height: size }}
        aria-hidden="true"
      />
      {label ? <span>{label}</span> : null}
    </div>
  );
}
